module.exports = __webpack_public_path__ + "static/20-year-cloud-1bdd61866771b7fa0e97da23cd78b035.png";